/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Search_Syntax_TitleInputs */



/**
* | output |
* | --- |
* | "Search Syntax" |
*
* @param {Help_Article_Search_Syntax_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_search_syntax_title = /** @type {((inputs?: Help_Article_Search_Syntax_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Search_Syntax_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Suchsyntax")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Syntaxe de recherche")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("搜索语法")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("搜尋語法")
	if (locale === "ko") return /** @type {LocalizedString} */ ("검색 문법")
	return /** @type {LocalizedString} */ ("Search Syntax")
});